export default __webpack_public_path__ + "static/media/cra-assets.7015ea8f.svg";